import { OrderServiceSelect } from '@components';
import { useTenantVat } from '@hooks';
import { L } from '@lib';
import { CreateServiceOrder, Order } from '@services';
import { useStore } from '@stores';
import { Button, Drawer, Row, Space } from 'antd';
import { observer } from 'mobx-react';
import React, { useEffect } from 'react';

interface IProps {
  open: boolean;
  loading?: boolean;
  order?: Order;
  onCancel: () => void;
  onSubmit: (serviceOrders: CreateServiceOrder[]) => Promise<void> | void;
}

const ReviseEstimateDrawer: React.FC<IProps> = observer(
  ({ open, loading, order, onCancel, onSubmit }) => {
    const tenantVat = useTenantVat();
    const { orderStore, serviceStore } = useStore();

    useEffect(() => {
      if (open && order) {
        serviceStore.initRevisionFromOrder(order, tenantVat);
      }
      if (!open) {
        serviceStore.clearRevisionSelectedServices();
      }
    }, [open, order, tenantVat, serviceStore]);

    const canSubmit = serviceStore.revisionSelectedServices.length > 0;

    const handleSave = async () => {
      if (!order) return;
      const payload = orderStore.buildServiceOrders(
        {
          selectedServices: serviceStore.revisionSelectedServices,
          selectedServiceParts: serviceStore.revisionServiceParts,
          tenantVat: serviceStore.tenantVat,
        },
        order.id
      ) as unknown as CreateServiceOrder[];
      // The parent handler re-hydrates the Job details tab after a successful revise.
      await onSubmit(payload);
    };

    const handleClose = () => {
      serviceStore.clearRevisionSelectedServices();
      onCancel();
    };

    return (
      <Drawer
        title={L('Revise Estimate')}
        placement="right"
        width="90vw"
        open={open}
        onClose={handleClose}
        destroyOnClose
        footer={
          <Row justify="end">
            <Space>
              <Button onClick={handleClose}>{L('Cancel')}</Button>
              <Button
                type="primary"
                loading={loading}
                disabled={!canSubmit}
                onClick={handleSave}
              >
                {L('Save')}
              </Button>
            </Space>
          </Row>
        }
      >
        <OrderServiceSelect variant="revision" atLeastOneService />
      </Drawer>
    );
  }
);

export default ReviseEstimateDrawer;
